import { Reveal } from '../ui/Reveal'
import { SectionHead } from '../ui/SectionHead'
import './Host.css'

const STEPS = [
  { n: 1, time: '~15 sec', title: 'Pick what and when', body: 'Choose an activity, from badminton to book clubs. Set a time, the number of spots, the level and a cost tag.' },
  { n: 2, time: '~10 sec', title: 'Drop the pin', body: 'Drag the map or type exact coordinates. Near a verified venue, the pin snaps to it.', coord: '28.45200, 77.09700 → Smash Arena' },
  { n: 3, time: 'as they come in', title: 'Approve who comes', body: "See each request's reliability score and approve the people you want. Then go play." },
]

export function Host() {
  return (
    <section id="host">
      <div className="wrap">
        <SectionHead eyebrow="Host" title={<>Host a plan in <em className="s">under a minute.</em></>}>
          Anyone can host. mauj handles approvals, reminders and no-shows.
        </SectionHead>
        <div className="steps">
          <div className="route" aria-hidden="true"><i /></div>
          {STEPS.map((s, i) => (
            <Reveal key={s.n} as="div" className="step glass" delay={i * 0.08}>
              <div className="sn"><span className="num">{s.n}</span><span className="secs">{s.time}</span></div>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
              {s.coord && <div className="coord">{s.coord}</div>}
            </Reveal>
          ))}
        </div>
        <div className="total"><span className="glass thin">Posting takes under a minute. Approving happens whenever requests arrive.</span></div>
      </div>
    </section>
  )
}
